var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowsUpdown = function SvgArrowsUpdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 16.3c.7-.5.8-1.4.3-2.1-.5-.7-1.4-.8-2.1-.3L8 15.1V8.5C8 7.7 7.3 7 6.5 7S5 7.7 5 8.5v6.6l-1.6-1.2c-.7-.5-1.6-.4-2.1.3s-.4 1.6.3 2.1L6.5 20l4.9-3.7zM8.6 3.7c-.7.5-.8 1.4-.3 2.1.5.7 1.4.8 2.1.3L12 4.9v6.6c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5V4.9l1.6 1.2c.7.5 1.6.4 2.1-.3s.4-1.6-.3-2.1L13.5 0 8.6 3.7z"
  })));
};
export default SvgArrowsUpdown;